import styled from "styled-components";

export const JackpotToastLogoAndTitleDefaultBox = styled.div`
    width: 43rem;
    max-width: 100%;
    margin: 0 auto;
    @media ${props => props.theme.mediaQuery.mAndBelow} {
        width: 100%;
    }
`;
